export const CLEAR_REDUX = 'CLEAR_REDUX';
export const GET_CATALOG = 'common/GET_CATALOG';
export const GET_CATALOG_RESULT = 'common/GET_CATALOG_RESULT';
export const CATALOG_LOADINGS = 'common/CATALOG_LOADINGS';
